import { curveLinear, curveMonotoneX, curveStepAfter } from '@visx/curve'

import type { ColorPatternName } from '../../Colors'
import type { ChartDataPoint } from '../ChartData'

export const ChartLineConstants = {
  defaultFillOpacity: 0.25,
  defaultLineWidth: 2,
  /**
   * Figma ellipse r=3 with a 2px centered stroke (8px outer diameter).
   * SVG stroke is centered on the path — do not add the stroke outside the fill.
   */
  defaultPointRadius: 3,
  defaultColorPattern: 'qualitative.default' as ColorPatternName,
  defaultLineStyle: 'solid' as const,
  defaultCurveType: 'linear' as const,
  pointStrokeWidth: 2,
  pointHighlightStrokeWidth: 4,
  dasharray: {
    dashed: '6 4',
    dotted: '2 3',
  },
  curves: {
    linear: curveLinear,
    smooth: curveMonotoneX,
    step: curveStepAfter,
  },
  /** VisX `defined` predicate — null y breaks the path (gap mode). */
  isPointDefined: (point: ChartDataPoint): boolean => point.y != null,
}
